import React from 'react'

import { reverse } from 'named-urls'
import { Link } from 'react-router-dom'

import {
  Box,
  Button,
  Divider,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
} from '@material-ui/core'

import Skeleton from '@material-ui/lab/Skeleton'

import { routes } from 'routes'
import { Permitted } from 'components/Permissions'
import helpers from 'helpers'

const ClientAddress = ({ clientId, address, isLoading, editable }) => {
  const Row = ({ name, title, formatter }) => {
    if (isLoading) {
      return (
        <TableRow hover>
          <TableCell width="30%">{title}</TableCell>
          <TableCell>
            <Skeleton width="100%" height={21} variant="rect" />
          </TableCell>
        </TableRow>
      )
    }

    return (
      <TableRow hover>
        <TableCell width="30%">{title}</TableCell>
        <TableCell>
          {formatter ? formatter(address[name]) : address[name]}
        </TableCell>
      </TableRow>
    )
  }

  return (
    <Paper>
      <Box
        p={2}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <Typography variant="h4">Endereço</Typography>
        <Permitted tag="update_customer">
          {editable ? (
            <Button
              color="primary"
              variant="contained"
              component={Link}
              to={reverse(routes.clients.editAddress, { clientId })}
            >
              Editar
            </Button>
          ) : null}
        </Permitted>
      </Box>

      <Divider />

      <Table>
        <TableBody>
          <Row
            name="postalCode"
            title="CEP"
            formatter={helpers.people.formatCep}
          />
          <Row name="street" title="Endereço" />
          <Row name="number" title="Número" />
          <Row name="neighborhood" title="Bairro" />
          <Row name="city" title="Cidade" />
          <Row name="state" title="Estado" />
          <Row name="complement" title="Complemento" />
        </TableBody>
      </Table>
    </Paper>
  )
}

ClientAddress.defaultProps = {
  address: {
    postalCode: '',
    street: '',
    number: '',
    neighborhood: '',
    city: '',
    state: '',
    complement: '',
  },
}

export default ClientAddress
